import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import CheckBoxCard from '@/components/Form/CheckBoxCard';

// STYLES
import { TitleContainer, Title } from '../styles';

const rokuLogo = getS3ImageUrl('/logos/services/new-roku.png');
const fireTVLogo = getS3ImageUrl('/logos/services/new-amazon-fire-tv.png');
const androidLogo = getS3ImageUrl('/logos/services/android-tv.svg');
const appleTVLogo = getS3ImageUrl('/logos/services/new-apple-tv.png');
const smartTVLogo = getS3ImageUrl('/logos/services/new-smart-tv.png');

const Streaming = ({ t, values, handleChange, handleBlur, onCheckboxChange, isRequired }) => {
  const variants = [
    {
      imageSrc: rokuLogo,
      value: 'roku',
      segmentText: 'Roku',
    },
    {
      imageSrc: fireTVLogo,
      value: 'amazon-fire-tv',
      segmentText: 'Amazon Fire TV',
    },
    {
      text: t('start.streaming.androidTv'),
      imageSrc: androidLogo,
      value: 'android-tv',
      segmentText: 'Android TV',
    },
    {
      text: t('start.streaming.appleTv'),
      imageSrc: appleTVLogo,
      value: 'apple-tv',
      segmentText: 'Apple TV',
      displayText: true,
    },
    {
      text: t('start.streaming.smartTv'),
      imageSrc: smartTVLogo,
      value: 'new-smart-tv',
      segmentText: 'Smart TV',
      displayText: true,
    },
    {
      text: t('start.streaming.noneAnyRecommendations'),
      imageSrc: '',
      value: 'none',
      segmentText: 'None, any recommendations?',
    },
  ];

  const handleCheckboxChange = event => {
    onCheckboxChange(event, handleChange);
  };

  return (
    <>
      <TitleContainer className="form-title">
        <Title
          className={clsx(isRequired && 'required')}
          variant="h4"
          align="center"
          component="h1"
        >
          {t('start.streaming.title')}
        </Title>
        <Typography variant="subtitle1" align="center">
          {t('start.streaming.subtitle')}
        </Typography>
      </TitleContainer>
      <Grid className="streaming-wdio" container spacing={1}>
        {variants.map(item => (
          <Grid item xs={6} sm={4} md={4} key={item.value}>
            <CheckBoxCard
              name="streaming"
              value={item.value}
              imageSrc={item.imageSrc}
              text={!item.imageSrc || item.displayText ? item.text : ''}
              segmentText={item.segmentText}
              fontSize="1.4rem"
              handleChange={handleCheckboxChange}
              handleBlur={handleBlur}
              checkedValue={values.streaming}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

Streaming.defaultPros = {
  isRequired: false,
};

Streaming.propTypes = {
  t: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
};

export default withTranslation()(React.memo(Streaming));
